import React from 'react'
import "./Footer.css"
const Footer = () => {
  return (
    <footer className="footer">
      <div className="footer-content">
       
        <p>
          © 2024 Made with <span className='text-danger'>&hearts;</span>  by Manish Sharma. All rights reserved. 
        </p>
        {/* <ul className="footer-links">
          <li><a href="#privacy">Privacy Policy</a></li>
          <li><a href="#legal">Legal</a></li>
          <li><a href="#gvsa">Subscriber Agreement</a></li>
          <li><a href="#refunds">Refunds</a></li>
          <li><a href="#cookies">Cookies</a></li>
        </ul>
        <ul className="footer-nav">
          <li><a href="#about">About</a></li>
          <li><a href="#jobs">Jobs</a></li>
          <li><a href="#distribution">Distribution</a></li>
          <li><a href="#support">Support</a></li>
        </ul> */}
        
      </div>
    </footer>
  )
}

export default Footer